import React, { useState } from "react";
import { toast } from "sonner";
import { AlertOctagon, Loader2 } from "lucide-react";
import api, { formatMoney2 } from "../../lib/api";

const pct = (v) => `${String(v).replace(".", ",")} %`;

export function TopeIncentivos({ a, p, onApplied }) {
  const [busy, setBusy] = useState(false);
  if (!p) return null;
  const exceso = a.total - (a.beneficio_extra || 0);
  const aplicar = async () => {
    setBusy(true);
    try {
      await api.post("/incentivos-coste/ajustar", { factor: p.factor });
      toast.success("Porcentajes ajustados para no superar el beneficio extra");
      onApplied?.();
    } catch { toast.error("No se pudo aplicar"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4 mb-4" data-testid="tope-incentivos">
      <div className="flex items-start gap-3">
        <AlertOctagon size={20} className="text-red-600 shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-red-900">
          <b>Los incentivos superan el beneficio extra en {formatMoney2(exceso)}.</b>{" "}
          {(a.beneficio_extra || 0) <= 0 ? "Este mes no hay beneficio extra de venta libre que los pague." : "Pagas más de lo que gana la farmacia con la subida de venta libre."}
          <div className="mt-2 text-red-800">
            Propuesta (el grupal ya se ajusta solo a su tramo):
            <ul className="list-disc ml-5 mt-1" data-testid="tope-propuesta">
              {p.bolsa_actual != null && <li>Bolsa individual por empleado: {formatMoney2(p.bolsa_actual)} → <b>{formatMoney2(p.bolsa_nueva)}</b></li>}
              <li>Stock parado: {pct(p.pct_1_actual)} → <b>{pct(p.pct_1)}</b> (1-2 años) y {pct(p.pct_2_actual)} → <b>{pct(p.pct_2)}</b> (más de 2 años)</li>
            </ul>
          </div>
          <p className="text-[11px] text-red-700/80 mt-2">Se aplica a los meses que aún no has cerrado. Puedes cambiar cada porcentaje a mano en su pestaña.</p>
        </div>
        <button className="btn btn-sm bg-red-600 text-white hover:bg-red-700 shrink-0" onClick={aplicar} disabled={busy} data-testid="tope-aplicar">
          {busy ? <Loader2 size={12} className="animate-spin" /> : null} Aplicar propuesta
        </button>
      </div>
    </div>
  );
}
